import React, { useState } from "react";
import "./TaxSummary.css";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import { Checkbox } from "@mui/material";

const initialTaxSummaryData = [
  { id: 1, for: "Federal", refund: "", payment: "" },
  { id: 2, for: "States", refund: "", payment: "", editable: false },
  { id: 3, for: "Cities", refund: "", payment: "", editable: false },
  { id: 4, for: "ITIN", refund: "", payment: "" },
  { id: 5, for: "Business Filing", refund: "", payment: "" },
  { id: 6, for: "FBAR", refund: "", payment: "" },
  { id: 7, for: "FACTA", refund: "", payment: "" },
  { id: 8, for: "Additional Fee", refund: "", payment: "" },
  { id: 9, for: "Other Fee", refund: "", payment: "" },
  { id: 10, for: "Discount", refund: "", payment: "" },
  { id: 11, for: "Total", refund: "", payment: "" },
];

const TaxSummary = () => {
  const [taxSummaryData, setTaxSummaryData] = useState(initialTaxSummaryData);
  const columns = [
    {
      key: "for",
      title: "For",
    },
    {
      key: "refund",
      title: "Refund/Due",
      render: (row) => (
        <input
          type="number"
          placeholder="$ Please Enter the Amount to Pay"
          className="cltdetails__taxsummary_cboxfield"
          style={{
            height: "45px",
            boxShadow: "0px 8px 16px 0px rgba(29, 66, 102, 0.06)",
            border: "1px solid rgba(255, 148, 122, 0.4)",
          }}
        />
      ),
    },
    {
      key: "payment",
      title: "Payment",
      render: (row) => (
        <input
          type="number"
          placeholder="$ Please Enter the Amount to Pay"
          className="cltdetails__taxsummary_cboxfield"
          style={{
            height: "45px",
            boxShadow: "0px 8px 16px 0px rgba(29, 66, 102, 0.06)",
            border: "1px solid rgba(255, 148, 122, 0.4)",
          }}
        />
      ),
    },
  ];
  return (
    <div className="cltdetails__taxsummary_page">
      <div className="cltdetails__taxsummary_contentwrap">
        <div className="cltdetails__taxsummary_cboxbanner">
          <span>Tax Summary</span>
        </div>
        <CustomTable
          columns={columns}
          headerStyle={{ background: "rgba(5, 89, 91, 0.85)" }}
          data={taxSummaryData}
        />
        <div
          className="cltdetails__taxsummary_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__taxsummary_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__taxsummary_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__taxsummary_savebtnwrap">
          <button className="cltdetails__taxsummary_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__taxsummary_contentbtnwrap">
        <div className="cltdetails__taxsummary_bottombtns">
          <button className="cltdetails__taxsummary_bbtnfilled">Submit</button>
          <button className="cltdetails__taxsummary_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaxSummary;
